/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trip_Force_End_SuccessInputs */

const vi_trip_force_end_success = /** @type {(inputs: Trip_Force_End_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã kết thúc chuyến thủ công`)
};

/**

* @param {Trip_Force_End_SuccessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trip_force_end_success = /** @type {((inputs?: Trip_Force_End_SuccessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trip_Force_End_SuccessInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trip_force_end_success(inputs)
});